import { withInstall } from '@vuemap/vue-amap-util'
import Polygon from './Polygon.vue'

export const ElAmapPolygon = withInstall(Polygon)
export default ElAmapPolygon
